<template>
    <div>
        <b-row>
            <b-col>
                <InputText
                        ref="address"
                        :label="Core.Definition.getDefinition('Adresse')"
                        v-model="dataValue.address"></InputText>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <InputText
                        ref="city"
                        :label="Core.Definition.getDefinition('Ville')"
                        v-model="dataValue.city"></InputText>
            </b-col>
            <b-col>
                <InputText
                        ref="zipcode"
                        :label="Core.Definition.getDefinition('Code postal')"
                        v-model="dataValue.zipcode"></InputText>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <InputProvince
                        ref="email"
                        :label="Core.Definition.getDefinition('Province')"
                        v-model="dataValue.province"></InputProvince>
            </b-col>
            <b-col>
                <InputCountry
                        ref="birthDate"
                        :label="Core.Definition.getDefinition('Pays')"
                        v-model="dataValue.country"></InputCountry>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <InputPhone
                        ref="phone"
                        :label="Core.Definition.getDefinition('Téléphone')"
                        v-model="dataValue.phone"></InputPhone>
            </b-col>
            <b-col>
                <InputText
                        ref="email"
                        :label="Core.Definition.getDefinition('Courriel')"
                        v-model="dataValue.email"></InputText>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import Vue from 'vue'
    import InputText from './InputText'
    import InputPhone from './InputPhone'
    import InputDatePicker from './InputDatePicker'
    import InputProvince from './InputProvince'
    import InputCountry from './InputCountry'
    Vue.use(require('vue-moment'))
    export default {
        name: 'InputAddress',
        components: {
            InputCountry,
            InputDatePicker,
            InputText,
            InputPhone,
            InputProvince
        },
        props: {
            value: {
                type: Object,
                default: function () {
                    return {
                        address: '',
                        province: '',
                        country: '',
                        city: '',
                        email: '',
                        phone: '',
                        zipcode: ''
                    }
                }
            }
        },
        computed: {
            open: {
                set(open) {
                    this.dataShow = open
                },
                get() {
                    return this.dataShow
                }
            },
            id: {
                set(id) {
                    this.dataId = id
                },
                get() {
                    return this.dataId
                }
            }
        },
        watch: {
            value(val) {
                this.dataValue = val
            },
            dataValue(val) {
                this.$emit('input', val)
            }
        },
        mounted() {
            this.dataValue = this.value
        },
        data: function () {
            return {
                Core: window.Core,
                dataShow: false,
                dataValue: {
                    firstname: '',
                    lastname: '',
                    email: '',
                    birthdate: null,
                    phone: '',
                    mobile: ''
                }
            }
        },
        methods: {
        }
    }
</script>
